import { render } from "./TestModal.vue?vue&type=template&id=2f5504cf&ts=true"
import script from "./TestModal.vue?vue&type=script&lang=ts"
export * from "./TestModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__